import React from "react";
import PropTypes from 'prop-types';
import { Button, FormGroup } from "reactstrap";
import { connect } from 'react-redux';
import { loginSuperAdmin } from '../redux/actions/authActions';
import { withToastManager } from 'react-toast-notifications';
import medieteticLogo from 'assets/img/medietetic-logo.svg';
import loginBackground from 'assets/img/background.png';
import BrandSelect from 'components/forms/BrandSelect';

class LoginFormSuperAdmin extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            error: undefined,
            company: null
        };

        this.toastManager = props.toastManager;
    }

    handleChange = (e) => {
        const value = e.target.value;
        this.setState({
            company: value === '' ? null : Number(value)
        });
    }

    login = (e) => {
        e.preventDefault();
        const userDataAdmin = {
            companyId: this.state.company,
            username: this.props.auth.userData.username,
            password: this.props.auth.userData.password
        };
        this.props.loginSuperAdmin(userDataAdmin, this.props.history);
    }

    render() {
        const { error, company } = this.state;
        const { companies } = this.props.auth;

        const companiesOptions = (companies || []).map((item, key) => (
            <option value={item.id} key={key}>{item.name}</option>
        ));

        return (
            <div className="login-page">
                <div className="login-card">
                    <div className="login-card-form">
                        <img
                            src={medieteticLogo}
                            alt="MeDietetic"
                            className="login-logo"
                        />
                        <h1 className="login-title">Odaberite tvrtku!</h1>
                        <p className="login-subtitle">
                            Za prijavu odaberite tvrtku u kojoj želite raditi promjene.
                        </p>
                        <form noValidate onSubmit={this.login} className="login-form" autoComplete="off">
                            <FormGroup className="login-field login-field-company">
                                <label htmlFor="company" className="login-label">
                                    Tvrtka
                                </label>
                                <BrandSelect
                                    name="company"
                                    id="company"
                                    value={company ?? ''}
                                    onChange={this.handleChange}
                                    toggleClassName="login-input login-select"
                                >
                                    <option value="" disabled>
                                        Odaberi tvrtku
                                    </option>
                                    {companiesOptions}
                                </BrandSelect>
                            </FormGroup>
                            {error && error.errorText && (
                                <span className="form-input-error-text">{error.errorText}</span>
                            )}
                            <Button
                                className="login-submit-btn"
                                disabled={!company}
                                type="submit"
                            >
                                Prijavi se
                            </Button>
                        </form>
                    </div>
                    <div className="login-card-visual">
                        <img src={loginBackground} alt="" className="login-background-image" />
                    </div>
                </div>
            </div>
        );
    }
}

LoginFormSuperAdmin.propTypes = {
    loginUser: PropTypes.func,
    auth: PropTypes.object.isRequired,
    UI: PropTypes.object.isRequired
}

const mapStateToProps = (state) => ({
    auth: state.auth,
    UI: state.UI
});

const mapActionsToProps = {
    loginSuperAdmin
}

export default connect(mapStateToProps, mapActionsToProps)(withToastManager(LoginFormSuperAdmin));
